module.exports = __webpack_public_path__ + "img/icon_map_62_on_011.3f0fd607.png";